import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LoggingService {
  private readonly endpoint = `${environment.apiUrl}/logs`; // Asumiendo que tienes una variable apiUrl en environment

  constructor(private http: HttpClient) {}

  logError(error: any) {
    // Aquí puedes formatear el error como necesites antes de enviarlo
    const errorInfo = {
      message: error.message || error.toString(),
      stack: error.stack || null,
      timestamp: new Date().toISOString(),
      location: window.location.href,
    };
    // Enviamos el error al backend. Usamos { observe: 'response' } para que no dispare el interceptor de errores si falla.
    return this.http.post(this.endpoint, errorInfo, { observe: 'response' });
  }
}
